module.exports = __webpack_public_path__ + "static/media/img_horse_main.fa2b8d89.png";